import { debounce } from 'lodash';
import { V2FilterPayload } from '../../../AssetFilter/functions/V2FilterPayload';
import type { AgGridReact } from 'ag-grid-react';
import type { IPagedTableProps } from '../../Components/ServerSideGrid';
import type { PagedQueryParams } from '../../Components/ServerSideGrid';

export function createGridFetcher<T>(agGridRef: React.RefObject<AgGridReact>) {
  const fetchData = (
    queryState: PagedQueryParams,
    assetFilters: string[],
    andOr: string,
    props: IPagedTableProps<T>,
    isCSV = false
  ) => {
    const pageSize = queryState.pageSize;

    if (pageSize === 0) {
      agGridRef.current?.api.setRowData([]);
      agGridRef.current?.api.showNoRowsOverlay();
      return;
    }

    const payload = props.filterControl
      ? V2FilterPayload(
        assetFilters,
        andOr,
        isCSV ? 0 : queryState.skip(),
        queryState.setSort(),
        isCSV ? props.rowData?.count : queryState.pageSize,
        undefined,
        queryState.filter,
        queryState.dateFilters.start,
        queryState.dateFilters.end,
        queryState.mapId
      )
      : undefined;

    props.handleFetchData(payload, isCSV, queryState, props.id);
  };

  const debounceFetchData = debounce(fetchData, 500);

  return { fetchData, debounceFetchData };
}
